import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/pagos.css";

const currency = new Intl.NumberFormat("es-EC", { style: "currency", currency: "USD" });

const EstadoChip = ({ estado }) => {
  if (!estado) return <span className="badge bg-light text-dark">Sin estado</span>;
  const map = {
    pendiente: "warning",
    parcial: "info",
    pagado: "success",
  };
  const color = map[estado] || "secondary";
  return <span className={`badge bg-${color} text-uppercase`}>{estado}</span>;
};

export default function PagosCobrosTable({
  deudas,
  loading,
  error,
  search,
  onSearch,
  onSelect,
  selectedId,
  onReload,
  cargosCount = {},
  cargosMonto = {},
}) {
  const navigate = useNavigate();
  return (
    <div className="management-card pagos-cobros-table h-100 d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <div>
          <p className="management-eyebrow mb-1">Cobranzas</p>
          <h6 className="mb-0">Matriculas con saldo pendiente</h6>
        </div>
        <div className="d-flex align-items-center gap-2">
          {loading && (
            <div className="text-muted small">
              <i className="bi bi-arrow-repeat me-2 spin" />
              Cargando...
            </div>
          )}
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onReload}>
            <i className="bi bi-arrow-repeat me-2" />
            Actualizar
          </button>
        </div>
      </div>

      <div className="row g-2 align-items-center mb-3">
        <div className="col-12 col-md-8 col-lg-7">
          <div className="input-group input-group-sm">
            <span className="input-group-text">
              <i className="bi bi-search" />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por estudiante, documento o codigo"
              value={search || ""}
              onChange={(e) => onSearch?.(e.target.value)}
            />
            {search && (
              <button type="button" className="btn btn-outline-secondary" onClick={() => onSearch?.("")}>
                Limpiar
              </button>
            )}
          </div>
        </div>
      </div>

      {error && <div className="alert alert-danger">Error: {error}</div>}

      <div className="table-responsive" style={{ WebkitOverflowScrolling: "touch" }}>
        <table className="table align-middle mb-0">
          <thead>
            <tr>
              <th>Matricula</th>
              <th>Estudiante</th>
              <th>Total a pagar</th>
              <th>Pagado</th>
              <th>Saldo pendiente</th>
              <th>Estado pago</th>
              <th className="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {deudas.length === 0 && (
              <tr>
                <td colSpan="7" className="text-center text-muted py-4">
                  {loading ? "Cargando..." : "Sin matriculas pendientes con los filtros actuales."}
                </td>
              </tr>
            )}
            {deudas.map((deuda) => (
              <tr
                key={deuda.id}
                className={selectedId === deuda.id ? "table-active" : ""}
                role="button"
                onClick={() => onSelect?.(deuda)}
              >
                <td>{deuda.codigoMatricula || `#${deuda.matriculaId}`}</td>
                <td
                  onClick={(e) => { e.stopPropagation(); if (deuda.estudianteId) navigate(`/dashboard/estudiantes/${deuda.estudianteId}/detalle`); }}
                  style={{ cursor: deuda.estudianteId ? "pointer" : "default" }}
                  title={deuda.estudianteId ? "Ver detalle del estudiante" : undefined}
                >
                  <div>{deuda.estudiante || "N/D"}</div>
                  {(cargosCount[deuda.matriculaId] || 0) > 0 && (
                    <div className="mt-1">
                      <span className="cargo-pill">
                        <i className="bi bi-box" />
                        {cargosCount[deuda.matriculaId]} cargo{cargosCount[deuda.matriculaId] !== 1 ? "s" : ""}
                      </span>
                    </div>
                  )}
                </td>
                <td>{currency.format(deuda.totalAPagar || 0)}</td>
                <td className="text-success">{currency.format(deuda.pagado || 0)}</td>
                <td>
                  <div className="fw-semibold">{currency.format(deuda.saldo || 0)}</div>
                  {(cargosMonto[deuda.matriculaId] || 0) > 0 && (
                    <div className="mt-1">
                      <span className="cargo-pill">
                        +({currency.format(cargosMonto[deuda.matriculaId])} cargos)
                      </span>
                    </div>
                  )}
                </td>
                <td>
                  <EstadoChip estado={deuda.estadoPago} />
                </td>
                <td className="text-center">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    title="Ver detalle"
                    style={{ minWidth: 36, minHeight: 36 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelect?.(deuda);
                    }}
                  >
                    <i className="bi bi-chevron-right" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
